/* ============================================================
   ADEQO GEVEL-OPBOUW. 3D-montage van composiet gevelbekleding
   (startclip, plank, montageclip, plank erover) met een meelopende
   stappenbalk, de doorsnede op schaal en de doorgesneden lat.
   Productpagina: snippets/opbouw-gevel.liquid via product-opbouw-adeqo.
   Composiet-landing: alleen de 3D-montage, snippets/col-gv-opbouw.liquid.
   Mockup: _system/mockups/gevel-pdp-opbouw-mockup.html (15-10-2026).

   Op de box [data-gevel-opbouw]:
     data-face / data-core   kleur van de huid en de WPC-kern
     data-dec                decimaalteken van de taal
     [data-go-3d]            lege <svg> voor de montage
     [data-go-x]             lege <svg> voor de doorsnede
     [data-go-detail]        lege <svg> voor de doorgesneden lat
     .gl__steps button       data-naam, data-maat, data-uitleg per stap
   SVG-labels via window.theme.t (sectie-keys go_*), NL als terugval.
   ============================================================ */

(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var GROOVE = '#1b1a1b', ALU = '#c9cdd1';

  function el(tag, attrs, parent) { var n = document.createElementNS(NS, tag); for (var a in attrs) n.setAttribute(a, attrs[a]); if (parent) parent.appendChild(n); return n; }
  function hexToRgb(x) { x = x.replace('#', ''); return [parseInt(x.substr(0, 2), 16), parseInt(x.substr(2, 2), 16), parseInt(x.substr(4, 2), 16)]; }
  function shade(hex, f) { return 'rgb(' + hexToRgb(hex).map(function (v) { return Math.max(0, Math.min(255, Math.round(v * f))); }).join(',') + ')'; }
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  var DEC = ',';
  function num(v) { return String(v).replace('.', DEC); }
  function mm(v) { return num(v) + ' mm'; }
  function t_(k, nl) { return (window.theme && typeof window.theme.t === 'function') ? window.theme.t(k, nl) : nl; }

  /* Profiel van één plank (Compolux Rhombus Highline 55, tekening Compolux):
     x = breedte 0..221, d = diepte vanaf de zichtkant 0..29. Latten 55, schaduwlijn 12,5,
     werkende breedte 202,5. Links de lip (18,5), rechts sponning en klikrand (6,5 hoog). */
  var LAT = 55, GAP = 12.5, LIP = 18.5, W = 221, T = 29, WORK = 202.5, GD = 17.4;
  var lats = [LIP, LIP + LAT + GAP, LIP + 2 * (LAT + GAP)]; // 18.5, 86, 153.5
  var PROFIEL = [
    [18.5, 0], [73.5, 0], [73.5, GD], [86, GD], [86, 0], [141, 0], [141, GD], [153.5, GD], [153.5, 0], [208.5, 0],
    [208.5, 17], [202.5, 17], [202.5, 22.5], [221, 22.5], [221, 29], [195, 29], [195, 24],
    [154.5, 24], [154.5, 29], [151.5, 29], [151.5, 24],
    [136, 24], [136, 29], [133, 29], [133, 24],
    [87, 24], [87, 29], [84, 29], [84, 24],
    [70.5, 24], [70.5, 29], [67.5, 29], [67.5, 24],
    [21.5, 24], [21.5, 29], [18.5, 29], [18.5, 21.3], [0, 21.3], [0, GD], [18.5, GD]
  ];
  var KAMERS = lats.map(function (x0, i) { return [x0 + 4.5, 4.5, (i === 2 ? 199 : x0 + LAT - 4.5), 20.5]; });
  // Gespiegeld zoals op de gevel (installatiegids Compolux/Oakio): links de klikrand, die
  // onderaan in de startclip valt; rechts de lip, die boven vastgezet wordt.
  PROFIEL = PROFIEL.map(function (p) { return [W - p[0], p[1]]; }).reverse();
  KAMERS = KAMERS.map(function (r) { return [W - r[2], r[1], W - r[0], r[3]]; });
  lats = lats.map(function (x) { return W - x - LAT; }).reverse(); // 12.5, 80, 147.5

  function el(tag, attrs, parent) { var n = document.createElementNS(NS, tag); for (var a in attrs) n.setAttribute(a, attrs[a]); if (parent) parent.appendChild(n); return n; }
  function hexToRgb(x) { x = x.replace('#', ''); return [parseInt(x.substr(0, 2), 16), parseInt(x.substr(2, 2), 16), parseInt(x.substr(4, 2), 16)]; }
  function shade(hex, f) { return 'rgb(' + hexToRgb(hex).map(function (v) { return Math.max(0, Math.min(255, Math.round(v * f))); }).join(',') + ')'; }
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  /* ---------------- 3D ---------------- */
  function draw3d(svg, kl, ui) {
    svg.innerHTML = '';
    var H = 120, k = 0.86, ox = 50, oy = 186, AX = 0.94, AY = 0.62;
    var VX = 0.62, VY = 0.94; // kijkrichting in het xy-vlak
    function P(x, y, z) { return [ox + (x * AX - y * AY) * k, oy + (x * 0.34 + y * 0.42 - z) * k]; }
    function pts(a) { return a.map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' '); }
    function dy(mmv, mmx) { mmx = mmx || 0; return [((mmx * AX - mmv * AY) * k).toFixed(1), ((mmx * 0.34 + mmv * 0.42) * k).toFixed(1)]; }
    var uid = 'g' + Math.random().toString(36).slice(2, 6);
    var defs = el('defs', {}, svg);
    var gr = el('linearGradient', { id: uid + 'v', x1: 0, y1: 0, x2: 1, y2: 0.25 }, defs);
    el('stop', { offset: 0, 'stop-color': shade(kl.face, 1.1) }, gr);
    el('stop', { offset: 1, 'stop-color': shade(kl.face, 0.9) }, gr);
    var fFace = 'url(#' + uid + 'v)';
    // WPC-korrel voor de kale kern: houtvezel en kunststof door elkaar
    var pat = el('pattern', { id: uid + 'k', width: 7, height: 7, patternUnits: 'userSpaceOnUse' }, defs);
    [[1, 1, 0.7, 1.35], [4.5, 2.2, 0.5, 0.7], [2.6, 4.6, 0.6, 1.25], [5.8, 5.6, 0.45, 0.75], [0.6, 5.8, 0.4, 1.4], [5.2, 0.4, 0.4, 1.3]].forEach(function (c) {
      el('circle', { cx: c[0], cy: c[1], r: c[2], fill: shade(kl.core, c[3]) }, pat);
    });
    var fGrain = 'url(#' + uid + 'k)';

    // Onderbalk: koker 42 x 30, haaks achter de planken (langs x)
    var XL = -44, XR = W + WORK + 26, zc = H * 0.5, zt = zc + 21, zb = zc - 21;
    var bar = el('g', {}, svg);
    el('polygon', { points: pts([P(XL, -30, zt), P(XR, -30, zt), P(XR, 0, zt), P(XL, 0, zt)]), fill: shade(ALU, 1.12) }, bar);
    el('polygon', { points: pts([P(XL, 0, zb), P(XR, 0, zb), P(XR, 0, zt), P(XL, 0, zt)]), fill: shade(ALU, 0.98) }, bar);
    el('polygon', { points: pts([P(XR, -30, zb), P(XR, 0, zb), P(XR, 0, zt), P(XR, -30, zt)]), fill: shade(ALU, 0.8) }, bar);
    el('polygon', { points: pts([P(XR, -28, zb + 2), P(XR, -2, zb + 2), P(XR, -2, zt - 2), P(XR, -28, zt - 2)]), fill: shade(ALU, 0.55) }, bar);

    // Clip als extrusie langs z (lengterichting van de plank)
    var CM = '#3f4245', cz0 = zc - 16, cz1 = zc + 16;
    function extrude(poly, parent, x0) {
      x0 = x0 || 0;
      var fs = [];
      for (var i = 0; i < poly.length; i++) {
        var a = poly[i], b = poly[(i + 1) % poly.length];
        var nx = -(b[1] - a[1]), ny = b[0] - a[0];
        if (nx * VX + ny * VY <= 0.0001) continue;
        fs.push({ key: (a[0] + b[0]) / 2 * VX + (a[1] + b[1]) / 2 * VY, a: a, b: b, fill: Math.abs(ny) > 0.01 ? shade(CM, 1.25) : shade(CM, 0.85) });
      }
      fs.sort(function (p, q) { return p.key - q.key; });
      fs.forEach(function (f) { el('polygon', { points: pts([P(x0 + f.a[0], f.a[1], cz0), P(x0 + f.b[0], f.b[1], cz0), P(x0 + f.b[0], f.b[1], cz1), P(x0 + f.a[0], f.a[1], cz1)]), fill: f.fill }, parent); });
      el('polygon', { points: pts(poly.map(function (c) { return P(x0 + c[0], c[1], cz1); })), fill: shade(CM, 1.55) }, parent);
    }
    function screw(parent, x, y) {
      var sh = P(x, y, zc);
      el('ellipse', { cx: sh[0].toFixed(1), cy: sh[1].toFixed(1), rx: 4.2, ry: 3, fill: '#1c1c1c', stroke: shade(CM, 1.8), 'stroke-width': 0.8 }, parent);
      el('path', { d: 'M' + (sh[0] - 1.8).toFixed(1) + ' ' + sh[1].toFixed(1) + 'h3.6M' + sh[0].toFixed(1) + ' ' + (sh[1] - 1.3).toFixed(1) + 'v2.6', stroke: shade(CM, 1.8), 'stroke-width': 0.7 }, parent);
    }
    // Startclip AS60: plaatje onder de eerste plank, met haken over de lip aan de onderzijde.
    // Plaat en haak apart: de haak ligt vóór de lip, dus die tekenen we na plank 1.
    var sPlate = el('g', {}, svg);
    extrude([[-27, 1.2], [20, 1.2], [20, 0], [-27, 0]], sPlate);
    screw(sPlate, -14, 1.2);
    var sHook = el('g', {}, svg);
    extrude([[-2.4, 1.2], [-2.4, 8.2], [6, 8.2], [6, 7.2], [-1.2, 7.2], [-1.2, 1.2]], sHook);

    // Plank: zijvlakken uit de profielranden, achter naar voor; dan de kopse kant
    function plank(x0, idx) {
      // Plank 1 krijgt een losse kern: de co-extrusielaag schuift er als huls omheen
      var coreG = idx === 0 ? el('g', {}, svg) : null;
      var g = el('g', {}, svg), faces = [];
      var n = PROFIEL.length;
      for (var i = 0; i < n; i++) {
        var a = PROFIEL[i], b = PROFIEL[(i + 1) % n];
        var ax = a[0], bx = b[0];
        // Lip van de tweede plank: het stuk onder de sponning van de eerste niet tekenen
        // Klikrand van de bovenste plank: de bovenkant ligt onder de lip van de onderste
        if (idx > 0 && a[1] === 22.5 && b[1] === 22.5) continue;
        var ay = T - a[1], by = T - b[1];
        var ex = bx - ax, ey = by - ay;
        // Profiel loopt met de klok mee (bovenrand naar rechts): buitennormaal (-ey, ex)
        var nx = -ey, ny = ex;
        if (nx * VX + ny * VY <= 0.0001) continue;
        var front = a[1] === 0 && b[1] === 0;
        var fill = front ? fFace : (nx > 0.01 && Math.abs(ny) < 0.01 ? shade(GROOVE, 1.35) : shade(GROOVE, 1.0));
        faces.push({ key: (ax + bx) / 2 * VX + (ay + by) / 2 * VY, ax: ax, ay: ay, bx: bx, by: by, fill: fill, front: front });
      }
      faces.sort(function (p, q) { return p.key - q.key; });
      faces.forEach(function (f, j) {
        if (coreG) {
          var cq = pts([P(x0 + f.ax, f.ay, 0), P(x0 + f.bx, f.by, 0), P(x0 + f.bx, f.by, H), P(x0 + f.ax, f.ay, H)]);
          el('polygon', { points: cq, fill: shade(kl.core, f.front ? 1.3 : (f.fill === shade(GROOVE, 1.35) ? 0.95 : 0.78)), stroke: shade(kl.core, 0.7), 'stroke-width': 0.4 }, coreG);
          el('polygon', { points: cq, fill: fGrain, opacity: 0.85 }, coreG);
        }
        el('polygon', { points: pts([P(x0 + f.ax, f.ay, 0), P(x0 + f.bx, f.by, 0), P(x0 + f.bx, f.by, H), P(x0 + f.ax, f.ay, H)]), fill: f.fill }, g);
        if (f.front) {
          var seed = Math.round(f.ax) + idx * 31 + 7;
          var rnd = function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
          for (var q = 0; q < 16; q++) {
            var gx = f.ax + 1.5 + rnd() * (f.bx - f.ax - 3), w = (rnd() - 0.5) * 1.8, pl = [];
            for (var s = 0; s <= 4; s++) pl.push(P(x0 + gx + Math.sin(s * 1.3 + q) * w, T, 2 + (H - 4) * s / 4));
            el('polyline', { points: pts(pl), fill: 'none', stroke: shade(kl.face, rnd() < 0.5 ? 0.82 : 1.15), 'stroke-width': (0.5 + rnd() * 0.7).toFixed(2), opacity: (0.4 + rnd() * 0.4).toFixed(2) }, g);
          }
        }
      });
      // Kopse kant (boven): kern met huid, kamers als gaten
      var cap = el('g', {}, svg);
      var d = 'M' + PROFIEL.map(function (p) { var s = P(x0 + p[0], T - p[1], H); return s[0].toFixed(1) + ' ' + s[1].toFixed(1); }).join('L') + 'Z';
      KAMERS.forEach(function (r) {
        var c = [P(x0 + r[0], T - r[1], H), P(x0 + r[2], T - r[1], H), P(x0 + r[2], T - r[3], H), P(x0 + r[0], T - r[3], H)];
        d += 'M' + c.map(function (s) { return s[0].toFixed(1) + ' ' + s[1].toFixed(1); }).join('L') + 'Z';
      });
      el('path', { d: d, fill: shade(kl.core, 1.15), 'fill-rule': 'evenodd', stroke: shade(kl.face, 1.05), 'stroke-width': 1.1, 'stroke-linejoin': 'round' }, cap);
      KAMERS.forEach(function (r) {
        var c = [P(x0 + r[0], T - r[1], H), P(x0 + r[2], T - r[1], H), P(x0 + r[2], T - r[3], H), P(x0 + r[0], T - r[3], H)];
        el('polygon', { points: pts(c), fill: '#151515', opacity: 0.85 }, cap);
      });
      if (!coreG) return { g: g, cap: cap };
      // Plank 1: de kern houdt de gevulde kopse kant, de huls alleen de rand
      var ring = el('g', {}, svg);
      el('path', { d: d.split('Z')[0] + 'Z', fill: 'none', stroke: shade(kl.face, 1.05), 'stroke-width': 1.8, 'stroke-linejoin': 'round' }, ring);
      cap.querySelector('path').setAttribute('stroke', 'none');
      return { g: g, cap: ring, coreG: coreG, coreCap: cap };
    }
    var p1 = plank(0, 0);
    // Montageclip AS59: plaatje op de onderbalk met een haak over de klikrand van plank 1
    var clip = el('g', {}, svg);
    extrude([[214, 12.6], [222.2, 12.6], [222.2, 1.2], [246, 1.2], [246, 0], [221, 0], [221, 11.7], [214, 11.7]], clip);
    screw(clip, 236, 1.2);
    var p2 = plank(WORK, 1);
    // Kopse kanten na alle zijvlakken, zodat ze altijd boven liggen
    svg.appendChild(p1.coreCap); svg.appendChild(p1.cap); svg.appendChild(p2.cap);

    function badge(parent, p, n, from) {
      if (from) el('line', { x1: from[0], y1: from[1], x2: p[0], y2: p[1], 'class': 'hw-build__lead' }, parent);
      el('circle', { cx: p[0], cy: p[1], r: 11, 'class': 'hw-build__badge' }, parent);
      var t = el('text', { x: p[0], y: p[1] + 4, 'class': 'hw-build__badge-n' }, parent); t.textContent = n;
    }
    var b1 = el('g', { 'class': 'hw-build__ann' }, svg);
    badge(b1, P(lats[1] + LAT / 2, T, H * 0.45), '2');
    var b2 = el('g', { 'class': 'hw-build__ann' }, svg);
    var k2 = P(WORK + lats[1] + LAT / 2, T - 12.5, H);
    badge(b2, [k2[0] + 6, k2[1] - 46], '5', k2);
    var b3 = el('g', { 'class': 'hw-build__ann' }, svg);
    var k3 = P(208.5, T - GD, 4);
    badge(b3, [k3[0] - 26, k3[1] + 40], '4', k3);
    var b4 = el('g', { 'class': 'hw-build__ann' }, svg);
    var k4 = P(240, 1.2, zc - 6);
    badge(b4, [k4[0] + 34, k4[1] + 34], '3', k4);
    var b5 = el('g', { 'class': 'hw-build__ann' }, svg);
    var k5 = P(-22, 1.2, zc - 8);
    badge(b5, [k5[0] - 24, k5[1] + 40], '1', k5);
    var b6 = el('g', { 'class': 'hw-build__ann' }, svg);
    var k6 = P(XR, -15, zc);
    badge(b6, [k6[0] + 30, k6[1] + 6], '6', k6);

    [b1, b2, b3, b4, b5, b6].forEach(function (n) { svg.appendChild(n); });
    var dims = el('g', { 'class': 'hw-build__ann' }, svg);
    function line(a, b) { el('line', { x1: a[0], y1: a[1], x2: b[0], y2: b[1] }, dims); }
    function text(p, s, anchor) { var t = el('text', { x: p[0], y: p[1], 'text-anchor': anchor || 'middle' }, dims); t.textContent = s; }
    var up = 16, a = P(lats[0], 0, H), b = P(WORK + lats[0], 0, H);
    line([a[0], a[1] - up], [b[0], b[1] - up]); line([a[0], a[1] - 3], [a[0], a[1] - up - 4]); line([b[0], b[1] - 3], [b[0], b[1] - up - 4]);
    text([(a[0] + b[0]) / 2 - 14, (a[1] + b[1]) / 2 - up - 16], mm(WORK));
    var dn = 14, c = P(WORK + lats[0] + LAT, T, 0), e = P(WORK + lats[1], T, 0);
    line([c[0], c[1] + dn], [e[0], e[1] + dn]); line([c[0], c[1] + 3], [c[0], c[1] + dn + 4]); line([e[0], e[1] + 3], [e[0], e[1] + dn + 4]);
    text([(c[0] + e[0]) / 2, (c[1] + e[1]) / 2 + dn + 17], mm(GAP));
    var XN = WORK + 202.5, off = 16, e0 = P(XN, 0, H), e1 = P(XN, T, H);
    line([e0[0] + off + 8, e0[1]], [e1[0] + off, e1[1]]);
    line([e0[0] + 3, e0[1]], [e0[0] + off + 12, e0[1]]); line([e1[0] + 3, e1[1]], [e1[0] + off + 4, e1[1]]);
    text([Math.max(e0[0], e1[0]) + off + 14, (e0[1] + e1[1]) / 2 + 4], mm(T), 'start');

    // p = 0 los, p = 1 gemonteerd: eerst plank 1 op de balk, dan plank 2 erover
    var SLEEVE = 58, OFF1 = 46, OFFC = 40, OFF2 = 40, OFF2X = 120;
    function render(p) {
      var tv = 1, ts = ease(clamp(p / 0.1)), t1 = ease(clamp((p - 0.08) / 0.24)), tc = ease(clamp((p - 0.34) / 0.18)), t2 = ease(clamp((p - 0.54) / 0.34));
      var dsx = dy(OFFC * (1 - ts)), d1 = dy(OFF1 * (1 - t1), 40 * (1 - t1)), dc = dy(OFFC * (1 - tc)), d2 = dy(OFF2 * (1 - t2), OFF2X * (1 - t2));
      [sPlate, sHook, b5].forEach(function (n) { n.setAttribute('transform', 'translate(' + dsx[0] + ' ' + dsx[1] + ')'); n.style.opacity = clamp(p / 0.04); });
      // Haak achter de plank zolang die nog onderweg is, ervoor zodra hij in de startclip staat
      if (t1 >= 0.999) { if (sHook.previousSibling !== p1.g) svg.insertBefore(sHook, p1.g.nextSibling); }
      else if (sHook.nextSibling !== p1.g) svg.insertBefore(sHook, p1.g);
      [p1.coreG, p1.coreCap].forEach(function (n) { n.setAttribute('transform', 'translate(' + d1[0] + ' ' + d1[1] + ')'); });
      var lift = (SLEEVE * (1 - tv) * k).toFixed(1);
      [p1.g, p1.cap, b1].forEach(function (n) { n.setAttribute('transform', 'translate(' + d1[0] + ' ' + (d1[1] - lift) + ')'); });
      // Zolang de huls los is, ligt de kopse kant van de kern eronder; daarna erboven
      if (tv < 0.999) { if (p1.coreCap.nextSibling !== p1.g) svg.insertBefore(p1.coreCap, p1.g); }
      else if (p1.coreCap.nextSibling !== p1.cap) svg.insertBefore(p1.coreCap, p1.cap);
      p1.coreG.style.display = 'none';
      p1.cap.firstChild.setAttribute('fill', tv < 0.999 ? '#2b2b2b' : 'none');
      clip.setAttribute('transform', 'translate(' + dc[0] + ' ' + dc[1] + ')');
      clip.style.opacity = clamp((p - 0.32) / 0.05);
      b4.setAttribute('transform', 'translate(' + dc[0] + ' ' + dc[1] + ')');
      b4.style.opacity = Math.min(clamp((p - 0.34) / 0.05), 1 - clamp((p - 0.84) / 0.05));
      [p2.g, p2.cap, b2].forEach(function (n) { n.setAttribute('transform', 'translate(' + d2[0] + ' ' + d2[1] + ')'); });
      b3.style.opacity = clamp((p - 0.8) / 0.1);
      dims.style.opacity = clamp((p - 0.86) / 0.1);
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { render(1); ui.step(1); ui.pin = function (i) { ui.step(i); }; return; }
    var HOLD_OPEN = 900, BUILD = 5200, HOLD_SHUT = 2800, OPEN = 1500, LOOP = HOLD_OPEN + BUILD + HOLD_SHUT + OPEN;
    function at(t) { t = t % LOOP; if (t < HOLD_OPEN) return 0; t -= HOLD_OPEN; if (t < BUILD) return t / BUILD; t -= BUILD; if (t < HOLD_SHUT) return 1; t -= HOLD_SHUT; return 1 - t / OPEN; }
    var BADGE = { 1: b5, 2: b1, 3: b4, 4: b3, 5: b2, 6: b6 };
    function stepAt(t) {
      t = t % LOOP;
      var p = at(t);
      if (t < HOLD_OPEN || p < 0.1) return 1;
      if (t < HOLD_OPEN + BUILD) return p < 0.34 ? 2 : p < 0.54 ? 3 : 4;
      t -= HOLD_OPEN + BUILD;
      return t < HOLD_SHUT / 2 ? 5 : 6;
    }
    var pinned = 0, pinnedUntil = 0, shown = 0;
    function show(i) {
      if (i === shown) return; shown = i;
      Object.keys(BADGE).forEach(function (k) { var c = BADGE[k].querySelector('circle'); if (c) c.classList.toggle('is-on', +k === i); });
      ui.step(i);
    }
    ui.pin = function (i) { pinned = i; pinnedUntil = performance.now() + 7000; show(i); };
    var raf = 0, t0 = 0;
    function frame(now) {
      if (!t0) t0 = now;
      render(at(now - t0));
      show(pinned && now < pinnedUntil ? pinned : stepAt(now - t0));
      raf = requestAnimationFrame(frame);
    }
    render(0);
    // Alleen animeren als de tekening in beeld is
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !raf) { t0 = 0; raf = requestAnimationFrame(frame); }
        else if (!e.isIntersecting && raf) { cancelAnimationFrame(raf); raf = 0; }
      });
    }, { threshold: 0.2 }).observe(svg);
  }

  /* ---------------- Doorsnede ---------------- */
  function drawX(svg, kl, uid) {
    svg.innerHTML = '';
    var X1 = W + WORK; // twee volle planken
    var y0 = 34;  // zichtkant
    function path(x0) {
      var d = 'M' + PROFIEL.map(function (p) { return (x0 + p[0]) + ' ' + (y0 + p[1]); }).join('L') + 'Z';
      KAMERS.forEach(function (r) { d += 'M' + (x0 + r[0]) + ' ' + (y0 + r[1]) + 'H' + (x0 + r[2]) + 'V' + (y0 + r[3]) + 'H' + (x0 + r[0]) + 'Z'; });
      return d;
    }
    var defs = el('defs', {}, svg);
    var cp = el('clipPath', { id: uid + 'x' }, defs);
    el('rect', { x: -90, y: 0, width: X1 + 90, height: 200 }, cp);
    var root = el('g', { 'clip-path': 'url(#' + uid + 'x)' }, svg);
    var XS = -30;
    // Onderbalk (lengte in beeld) en muur
    var yb = y0 + T;
    el('rect', { x: XS, y: yb, width: X1 - XS + 40, height: 30, 'class': 'gx-alu' }, root);
    el('rect', { x: XS, y: yb + 2, width: X1 - XS + 40, height: 26, 'class': 'gx-alu-in' }, root);
    el('line', { x1: XS, y1: yb + 31.5, x2: X1 + 40, y2: yb + 31.5, 'class': 'gx-wall' }, root);
    // Twee planken: huid (co-extrusie) als dikke rand, kern erin
    [0, WORK].forEach(function (x0) {
      el('path', { d: path(x0), fill: kl.core, 'fill-rule': 'evenodd', stroke: kl.face, 'stroke-width': 1.4, 'stroke-linejoin': 'round' }, root);
    });
    // zwarte schaduwlijn: groefbodems en de naad
    [[67.5, 80], [135, 147.5], [202.5, 215], [WORK + 67.5, WORK + 80], [WORK + 135, WORK + 147.5]].forEach(function (g) {
      el('line', { x1: g[0] + 0.7, y1: y0 + GD, x2: g[1] - 0.7, y2: y0 + GD, stroke: GROOVE, 'stroke-width': 1.6 }, root);
    });

    // Montageclip: plaatje op de onderbalk, haak over de klikrand van plank 1, schroef in de balk
    el('path', { d: 'M214 ' + (yb - 12.6) + 'H222.2V' + (yb - 1.2) + 'H246V' + yb + 'H221V' + (yb - 11.7) + 'H214Z', fill: '#3f4245' }, root);
    el('path', { d: 'M232.5 ' + (yb - 1.6) + 'H239.5L237.2 ' + yb + 'H234.8Z', fill: '#1c1c1c' }, root);
    el('rect', { x: 235.1, y: yb, width: 1.8, height: 20, fill: '#1c1c1c' }, root);
    // Startclip: plaatje onder de eerste plank, haak over de lip aan de onderzijde
    el('path', { d: 'M-27 ' + (yb - 1.1) + 'H20V' + yb + 'H-27Z' + 'M-2.4 ' + (yb - 1.1) + 'V' + (yb - 8.2) + 'H6V' + (yb - 7.2) + 'H-1.2V' + (yb - 1.1) + 'Z', fill: '#3f4245' }, root);
    el('path', { d: 'M-17.5 ' + (yb - 1.6) + 'H-10.5L-12.8 ' + yb + 'H-15.2Z', fill: '#1c1c1c' }, root);
    el('rect', { x: -14.9, y: yb, width: 1.8, height: 20, fill: '#1c1c1c' }, root);
    var ann = el('g', {}, svg);
    function dim(dpath) { el('path', { d: dpath, 'class': 'po-x__dim' }, ann); }
    function txt(x, y, s, cls, anchor) { var t = el('text', { x: x, y: y, 'class': cls }, ann); if (anchor) t.setAttribute('text-anchor', anchor); t.textContent = s; }
    // Boven: latten en schaduwlijnen van plank 1 en de naad
    lats.forEach(function (x) { txt(x + LAT / 2, y0 - 6, '55', 'po-x__w'); });
    [[67.5, 80], [135, 147.5], [202.5, 215]].forEach(function (g) { txt((g[0] + g[1]) / 2, y0 - 6, num(GAP), 'po-x__g'); });
    // Werkende breedte
    var yw = 12;
    dim('M' + lats[0] + ' ' + (yw - 3) + 'V' + (yw + 3) + 'M' + (lats[0] + WORK) + ' ' + (yw - 3) + 'V' + (yw + 3) + 'M' + lats[0] + ' ' + yw + 'H' + (lats[0] + WORK));
    var t = el('text', { x: lats[0] + WORK / 2, y: yw - 3, 'class': 'po-x__tot' }, ann); t.textContent = t_('go_work_width', num(WORK) + ' mm werkende breedte');
    // Onder: plankmaat 221
    var yp = yb + 44;
    dim('M0 ' + (yp - 4) + 'V' + (yp + 4) + 'M' + W + ' ' + (yp - 4) + 'V' + (yp + 4) + 'M0 ' + yp + 'H' + W);
    txt(W / 2, yp + 12, '221 mm ' + t_('go_plank_size', 'plankmaat'), 'po-x__tot');
    // Links: dikte 29 en onderbalk 30
    dim('M-34 ' + y0 + 'H-42M-34 ' + yb + 'H-42M-38 ' + y0 + 'V' + yb + 'M-34 ' + (yb + 30) + 'H-42M-38 ' + yb + 'V' + (yb + 30));
    txt(-45, y0 + T / 2 + 2.5, '29', 'po-x__t', 'end');
    txt(-45, yb + 17.5, '30', 'po-x__t', 'end');
    // Rechts: klikrand 6,5 van plank 1, met pijl naar label
    // Co-extrusie 0,7: pijl naar de huid bovenop lat 2 van plank 2
    var cx = WORK + lats[0] + 30;
    el('path', { d: 'M' + cx + ' ' + (y0 + 0.4) + 'L' + (cx + 12) + ' ' + (y0 - 14) + 'H' + (cx + 22), 'class': 'po-x__pijl' }, ann);
    txt(cx + 24, y0 - 11.5, t_('go_coex', 'co-extrusielaag 0,7'), 'po-x__t');
    // Onderbalk label
    txt(X1 - 8, yb + 17.5, t_('go_beam', 'aluminium onderbalk 42 × 30'), 'po-x__t', 'end');
    el('path', { d: 'M-22 ' + (yb - 0.6) + 'L-4 ' + (yb + 15) + 'H6', 'class': 'po-x__pijl' }, ann);
    txt(8, yb + 17.5, t_('go_startclip', 'startclip'), 'po-x__t');
    // Klikverbinding label
    el('path', { d: 'M209 ' + (y0 + 19.3) + 'L200 ' + (yb + 15) + 'H190', 'class': 'po-x__pijl' }, ann);
    txt(188, yb + 17.5, t_('go_click', 'klikverbinding'), 'po-x__t', 'end');
    el('path', { d: 'M242 ' + (yb - 0.6) + 'L258 ' + (yb + 15) + 'H266', 'class': 'po-x__pijl' }, ann);
    txt(268, yb + 17.5, t_('go_clip', 'montageclip'), 'po-x__t');
    svg.setAttribute('viewBox', '-62 0 ' + (X1 + 62 + 20) + ' ' + (yp + 18));
  }

  /* ---------------- Detail: doorgesneden lat ---------------- */
  function drawDetail(svg, kl, uid) {
    svg.innerHTML = '';
    // Uitsnede rond lat 2, vijf keer vergroot
    var S = 8, X0 = 64, D0 = -9, ox = 0, oy = 0;
    function X(x) { return ox + (x - X0) * S; }
    function Y(d) { return oy + (d - D0) * S; }
    var d = 'M' + PROFIEL.map(function (p) { return X(p[0]).toFixed(1) + ' ' + Y(p[1]).toFixed(1); }).join('L') + 'Z';
    var holes = KAMERS.map(function (r) { return 'M' + X(r[0]) + ' ' + Y(r[1]) + 'H' + X(r[2]) + 'V' + Y(r[3]) + 'H' + X(r[0]) + 'Z'; }).join('');
    var defs = el('defs', {}, svg);
    var cp = el('clipPath', { id: uid + 'c' }, defs);
    el('path', { d: d + holes, 'clip-rule': 'evenodd' }, cp);
    var fade = el('linearGradient', { id: uid + 'f', x1: 0, y1: 0, x2: 1, y2: 0 }, defs);
    el('stop', { offset: 0, 'stop-color': '#f6f7f8', 'stop-opacity': 1 }, fade);
    el('stop', { offset: 0.12, 'stop-color': '#f6f7f8', 'stop-opacity': 0 }, fade);
    el('stop', { offset: 0.88, 'stop-color': '#f6f7f8', 'stop-opacity': 0 }, fade);
    el('stop', { offset: 1, 'stop-color': '#f6f7f8', 'stop-opacity': 1 }, fade);
    var g = el('g', { 'clip-path': 'url(#' + uid + 'c)' }, svg);
    el('rect', { x: 0, y: 0, width: 400, height: 300, fill: kl.core }, g);
    // korrel in de kern
    var seed = 11; function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
    for (var i = 0; i < 260; i++) el('circle', { cx: (rnd() * 400).toFixed(1), cy: (rnd() * 300).toFixed(1), r: (0.6 + rnd() * 1.1).toFixed(1), fill: shade(kl.core, rnd() < 0.5 ? 0.82 : 1.2), opacity: 0.7 }, g);
    // huid: 0,7 mm langs de hele rand (binnen het profiel)
    el('path', { d: d + holes, fill: 'none', stroke: kl.face, 'stroke-width': 0.7 * S * 2, 'stroke-linejoin': 'round' }, g);
    // zwarte schaduwlijn op de groefbodems
    [[67.5, 80], [135, 147.5]].forEach(function (q) { el('rect', { x: X(q[0]), y: Y(GD) - 0.7 * S, width: (q[1] - q[0]) * S, height: 0.7 * S, fill: GROOVE }, g); });
    el('rect', { x: 0, y: 0, width: 400, height: 300, fill: 'url(#' + uid + 'f)' }, svg);
    // labels
    function lab(x1, y1, x2, y2, t1, t2) {
      el('path', { d: 'M' + x1 + ' ' + y1 + 'L' + x2 + ' ' + y2 + 'H' + (x2 + 10), 'class': 'gdd__lead' }, svg);
      el('circle', { cx: x1, cy: y1, r: 3.5, fill: '#1a1a1a', stroke: '#fff', 'stroke-width': 1.5 }, svg);
      var a = el('text', { x: x2 + 14, y: y2 - 3, 'class': 'gdd__lab' }, svg); a.textContent = t1;
      var b = el('text', { x: x2 + 14, y: y2 + 16, 'class': 'gdd__sub' }, svg); b.textContent = t2;
    }
    lab(X(92), Y(0) + 2.8, 150, 30, t_('go_d_coex', 'Co-extrusielaag 0,7 mm'), t_('go_d_coex_sub', 'kleur en bescherming'));
    lab(X(82.2), Y(14), 40, 268, t_('go_d_core', 'WPC-kern'), t_('go_d_core_sub', 'houtvezel en gerecycled plastic'));
    lab(X(104), Y(15), 262, 236, t_('go_d_hole', 'Holle kamer'), t_('go_d_hole_sub', 'minder gewicht'));
  }

  function mount(box) {
    if (!box || box.__gevelOpbouw) return;
    box.__gevelOpbouw = true;
    DEC = box.getAttribute('data-dec') || ',';
    var kl = { face: box.getAttribute('data-face') || '#c89a6c', core: box.getAttribute('data-core') || '#6f6658' };
    var uid = 'go' + Math.random().toString(36).slice(2, 7);
    var txt = box.querySelector('.gl__txt'), btns = box.querySelectorAll('.gl__steps button');
    var ui = {
      pin: function () {},
      step: function (i) {
        btns.forEach(function (b) {
          var on = b.getAttribute('data-i') === String(i);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on && txt) {
            txt.querySelector('b').textContent = b.getAttribute('data-naam');
            txt.querySelector('em').textContent = b.getAttribute('data-maat');
            txt.querySelector('span').textContent = b.getAttribute('data-uitleg');
          }
        });
      }
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { ui.pin(+b.getAttribute('data-i')); }); });
    var s3 = box.querySelector('[data-go-3d]'), sx = box.querySelector('[data-go-x]'), sd = box.querySelector('[data-go-detail]');
    if (s3) draw3d(s3, kl, ui);
    if (sx) drawX(sx, kl, uid);
    if (sd) drawDetail(sd, kl, uid);
  }

  window.AdeqoGevelOpbouw = { mount: mount };

  function boot() { document.querySelectorAll('[data-gevel-opbouw]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
